import { useEffect, useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, Sparkles } from "lucide-react";

export default function ClientLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) navigate("/login", { replace: true });
    else if (user.role && user.role !== "client") {
      navigate(user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
    }
  }, [user, navigate]);

  if (!user || user.role !== "client") return null;

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-40">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2">
            <Sparkles className="h-5 w-5 text-indigo-600" />
            <span className="font-semibold text-slate-900">Affilitube</span>
            <span className="ml-2 text-xs uppercase tracking-wide bg-slate-100 text-slate-600 px-2 py-0.5 rounded">
              Preview access
            </span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-slate-600 hidden sm:inline" data-testid="client-user-email">{user.email}</span>
            <Button variant="ghost" size="sm" onClick={() => { logout(); navigate("/login"); }} data-testid="client-logout-btn">
              <LogOut className="h-4 w-4 mr-1" /> Logout
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-6">
        <Outlet />
      </main>
      <footer className="max-w-6xl mx-auto px-4 py-6 mt-8 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
        <span>&copy; {new Date().getFullYear()} Affilitube</span>
        <a href="mailto:support@affilitube.com" className="hover:text-slate-800" data-testid="client-footer-contact-email">
          Questions? support@affilitube.com
        </a>
      </footer>
    </div>
  );
}
